import LocalStore from './local_store'
import supportedThemes from '../components/theme_picker/supported_themes'

export class UserSettings extends Backbone.Model {
  get defaults () {
    return {
      // 'auto' if it is supported otherwise 'light'
      theme: supportedThemes().auto ? 'auto' : 'light',
      last_updated: new Date().toUTCString()
    }
  }

  get idAttribute () { return 'user_id' }

  initialize () {
    this.on('change:theme', this.save)
  }

  save () {
    this.set({ last_updated: new Date().toUTCString() })
    this.trigger('save', {})
  }
}

export default class Settings extends LocalStore {
  get model () { return UserSettings }
  get key () { return 'singularity_settings' }
}
